import styled from 'styled-components';
import { media } from 'designsystem/index';

const LeftButtonWrapper = styled.div`
  position: absolute;
  top: 215px;
  z-index: 25;
  padding-left: 20px;

  ${media.tablet`
    top: 255px;
 `};

  ${media.desktop`
    top: 240px;
  `};
`;

export default LeftButtonWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/LeftButtonWrapper.jsx